import { render, staticRenderFns } from "./home.vue?vue&type=template&id=523c2a7a&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=523c2a7a&lang=less&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=523c2a7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c2a7a",
  null
  
)

export default component.exports